<template>
<div class="login">
  <form class="form-signin">
    <input type="text"
      name="account" 
      v-model="account" 
      placeholder="請輸入帳號" />
    <input type="password" 
      name="password" 
      v-model="password" 
      placeholder="請輸入密碼" />

    <div v-if="comfirm" class="warning">帳號或密碼未輸入</div>
    <div v-if="userLoginError" class="warning">帳號或密碼錯誤</div>
    <div class="form-submit" @click="submitLogin">送出</div>

    <div @click="goForgetPassword" class="form-signin__fg_pw">忘記密碼</div>
  </form>

  <div class="login-desc">
    <p>登入功能僅限 OneBrandMaster 合作夥伴使用，</p>
    <p>如有登入需求，請與<a target="_blank" :href="`mailto:${email}`">我們聯繫！</a></p>
  </div>

</div>
</template>

<script>
  import { 
    mapGetters,
    mapActions, 
  } from 'vuex';

  import Logo from '../common/logo';

  export default {
    name: 'user_login',
    components: {
      Logo,
    },
    data() {
      return {
        email: 'Hello@onead.com.tw',
        comfirm: false,
        account: '',
        password: '',
      };
    },
    computed: {
      ...mapGetters({
        userStatus: 'getUserLoginStatus',
        userLoginError: 'getUserLoginError',
      }),
    },
    methods: {
      ...mapActions([
        'actionLoginIn',
        'changePopupType',
      ]),
      submitLogin() {
        if (this.account.length > 0 && this.password.length > 0) {

          const userData = {
            email: this.account,
            password: this.password,
            router: this.$router,
          };

          this.comfirm = false;
          this.actionLoginIn(userData);
          return;
        }
        
        this.comfirm = true;
      },
      goForgetPassword() {
        this.changePopupType('fg');
      },
    },
  };
</script>

<style lang="scss">
.login {
  display: flex;
  flex-direction: column;
  .login-desc {
    margin: auto;
    margin-top: 50px;
    text-align: center;
    p {
      font-size: 14px;
      color: #4a4a4a;
    }
    a {
      color: #e89022;
      transition: all, .3s;
      &:hover {
        color: darken(#e89022, 10%)
      }
    }
  }
}

.form-signin {
  margin: auto;
  width: 350px;
  input {
    display: block;
    margin: 10px 0;
    padding: 10px;
    width: 350px;
    height: 44px;
    background-color: transparent;
    border-bottom: 1px solid #ff9d00;
    font-size: 20px;
    font-weight: 300;
    color: #333;
    transition: all .3s;
    &:-webkit-autofill {
      background-color: #333 !important;
    }
    &[name="account"]:focus, 
    &[name="password"]:focus {
      margin: 20px 0;
      border-bottom: 2px solid #ed5e00;
    }
  }
  &__fg_pw {
    display: block;
    margin-top: 10px;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: right;
    cursor: pointer;
    transition: all .3s;

    font-size: 14px;
    color: #3583be;
    &:hover {
      color: darken(#3583be, 10%);
      text-decoration: underline;
    }
  }
  .warning {
    margin-top: 20px;
    width: 100%;
    text-align: right;
    color: #d0011b;
    font-size: 14px;
  }
  .form-submit {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    height: 50px;
    background-color: #ff9d00;
    font-size: 17px;
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background-color: #e68d00;
      transition: all .3s;
    }
  }
  // > input {
  //   &[name="account"]:focus, &[name="password"]:focus {
  //     width: 175px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// Login.vue?af1d50a2